import React, { useEffect, useState } from "react";
import "./App.css";
import Layout from "./components/Layout";
import AuthPage from "./pages/AuthPage";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import DriverDashboard from "./pages/DriverDashboard";
import { api } from "./api/client";
import { Loader } from "./components/Loader";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const me = await api("/auth/me");
        setUser(me.user);
      } catch {
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const logout = async () => {
    await api("/auth/logout", { method: "POST" });
    localStorage.removeItem("token");
    setUser(null);
  };

  if (loading)
    return (
      <Loader />
    );

  return (
    <Layout user={user} onLogout={logout}>
      {!user && <AuthPage onAuth={setUser} />}
      {user && user.role === "admin" && <AdminDashboard />}
      {user && user.role === "driver" && <DriverDashboard />}
      {user && user.role === "passenger" && <UserDashboard />}
    </Layout>
  );
}

export default App;
